const BASE_URL = "https://tour.collegefairs.ae";
// const BASE_URL = "http://192.168.1.26:8081";
// const BASE_URL = "http://localhost:7008";

export { BASE_URL };
